import { render, staticRenderFns } from "./DevicesLatest.vue?vue&type=template&id=2289e406&"
import script from "./DevicesLatest.vue?vue&type=script&lang=js&"
export * from "./DevicesLatest.vue?vue&type=script&lang=js&"
import style0 from "./DevicesLatest.vue?vue&type=style&index=0&id=2289e406&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports